<template>
    <div id="AvatorCut">
        <div class="picUpload-wraper">
                <div class="pic-left-wraper">
                    <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :info="true"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canScale="option.canScale"
                        :canMoveBox="option.canMoveBox"
                        :fixed="option.fixed"
                        :fixedNumber="option.fixedNumber"
                        :fixedBox="option.fixedBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :autoCropWidth="option.autoCropWidth"
                        :autoCropHeight="option.autoCropHeight"
                        :centerBox="option.centerBox"
                        :high="option.high"
                        :infoTrue="option.infoTrue"
                        :enlarge="option.enlarge"
                        @realTime="realTime"
                    ></vueCropper>
                </div>
                <div class="pic-right-wraper">
                    <div class="pic-right">
                        <el-upload
                            action=""
                            :show-file-list="false"
                            :auto-upload="false"
                            :file-list="filelist"
                            :on-change="handleChange"
                            class="upload-button">
                            <el-button> 更换LOGO</el-button>
                        </el-upload>
                        <p >支持jpg、jpeg、gif、png、bmp格式;</p>
                        <p >最佳尺寸为120*120像素</p>
                        <p >大小不超过1Mb</p>
                    </div>
                    <div :style="previewStyle1">
                        <div class="previer-text">LOGO预览</div>
                        <div :style="previews.div" class="preview">
                            <img :src="previews.url" >
                        </div>
                    </div>
                </div>
            </div>
            <div style="text-align:center;margin-top:30px">
                <el-button style="margin-right:10px" @click="closeAvatorDialog">取 消</el-button>
                <el-button type="primary" @click="saveHeadPic">保 存</el-button>
            </div>
            
    </div>
</template>

<script>
    import {VueCropper} from 'vue-cropper'
    export default {
        components:{
           VueCropper
        },
        data(){
            return{
                previewStyle1:{},
                previews:{},
                filelist:[],
                option:{
                    img:'',
                    outputSize: 1, // 裁剪生成图片的质量 1 0.1 - 1
                    outputType: "png", //  裁剪生成图片的格式 jpg (jpg 需要传入jpeg)  jpeg || png || webp
                    info: true, //  裁剪框的大小信息  true  true || false
                    canScale: true, // 图片是否允许滚轮缩放  true  true || false
                    autoCrop: true, //是否默认生成截图框 false true || false
                    autoCropWidth: 120, //默认生成截图框宽度 容器的80%  0~max
                    autoCropHeight: 120, //默认生成截图框高度  容器的80%  0~max
                    fixed: true, //是否开启截图框宽高固定比例  true  true | false
                    fixedNumber: [1, 1], //截图框的宽高比例 [1, 1]  [宽度, 高度]
                    full: false, //是否输出原图比例的截图  false true | false
                    fixedBox:true, //固定截图框大小 不允许改变  false true | false
                    canMove: true, //上传图片是否可以移动  true  true | false
                    canMoveBox: true, //截图框能否拖动 true  true | false
                    original: false, //上传图片按照原始比例渲染 false true | false
                    centerBox: false, //截图框是否被限制在图片里面  false true | false
                    high:false, //是否按照设备的dpr 输出等比例图片  true  true | false
                    infoTrue: false, //true 为展示真实输出图片宽高 false 展示看到的截图框宽高 false true | false
                    maxImgSize: 2000, //限制图片最大宽度和高度 2000  0-max
                    enlarge: 1, //图片根据截图框输出比例倍数 1 0-max(建议不要太大不然会卡死的呢)
                    mode: "contain" //图片默认渲染方式  contain contain , cover, 100px, 100% auto
                },
            }
        },
        methods:{
            handleChange(file,filelist){//选择文件，上传前，上传成功，上传失败
                console.log(file);
                console.log(filelist);
                let { type,size } = file.raw;
                console.log(type,size)
                if (!/(png|gif|jpeg|jpg|bmp)/i.test(type)) {
                    this.$message.error("图片格式不正确~~");
                    this.filelist=[];
                    return false;
                }
                if (size > 1 * 1024 * 1024) {
                    this.$message.error("图片过大，请上传小于1MB的文件~~");
                    this.filelist=[];
                    return false;
                }
                if(filelist.length>0){
                    this.filelist=[filelist[filelist.length - 1]];
                    
                }
                this.option.img = URL.createObjectURL(file.raw);

            },
            realTime(data){
                console.log(data)
                this.$refs.cropper.getCropBlob(blob => {
                    console.log(blob)
                    // do something
                    let url = window.URL.createObjectURL(blob);
                    data.url=url;
                    this.previews = data;
                });
            },
            closeAvatorDialog(){
                this.$emit('closeAvatorDialog')
            },
            saveHeadPic(){
                let that=this;
                if(!that.option.img){
                    that.$message.error('请上传图片')
                    return
                }
                let formData = new FormData();
                this.$refs.cropper.getCropBlob(blob => {
                    console.log(blob);
                    const file=new window.File([blob],that.filelist[0].name);
                    console.log(file);
                    if(file.size<5*1024){
                        that.$message.error('裁剪后图片小于5KB，请重新裁剪')
                        return 
                    }
                    console.log(file)
                    this.$emit('logoCutSuccess',blob)
                    // formData.append("formFile",a);
                    // for(let [a,b] of formData.entries()){
                    //     console.log(a,b)
                    // }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    #AvatorCut{
        .picUpload-wraper{
                    display: flex;
                    justify-content: space-between;
                    .pic-left-wraper{
                        width: 300px;
                        height: 300px;
                    }
                    .pic-right-wraper{
                        width: 230px;
                        height: 300px;
                        .pic-right{
                            margin-top: 20px;
                            .upload-button{
                                margin-bottom: 15px;
                            }
                            p{
                                text-align: center;
                                font-family: MicrosoftYaHei;
                                font-size: 12px;
                                color: #999999;
                                line-height: 20px;
                                font-weight: 400;

                            }
                        }
                        .previer-text{
                            font-size: 14px;
                            margin-top: 15px;
                        }
                        .preview {
                                width: 120px;
                                height: 120px;
                                margin: 5px auto 20px auto;
                                border-radius: 50%;
                                border: 1px solid #ccc;
                                background-color: #ccc;
                                overflow: hidden;
                            }
                    }
                }
    }
</style>


// WEBPACK FOOTER //
// src/view/commonRepeat/AvatorCut.vue